export const checkIfStatusIsForbidden = (error) => {
  if (error.status === 403 || error.status === 401 || error.status === 400) {
    const currentPath = window.location.pathname;
    // Don't redirect if user is on login or register pages
    // These pages handle their own error states
    const publicPaths = ['/', '/login', '/register', '/entrar', '/cadastro'];
    const isPublicPath =
      publicPaths.includes(currentPath) ||
      currentPath.endsWith('/entrar') ||
      currentPath.endsWith('/cadastro');
    if (!isPublicPath) {
      window.location.href = '/';
    }
  }
};
